import { Award, Landmark, Cpu, Truck, ShieldCheck, Gavel } from 'lucide-react';

// Honors & distinctions: the signals of an extraordinary track record.
export const honorsData = [
    {
        id: 1,
        icon: <Award size={24} />,
        title: 'IEEE Senior Member',
        org: 'IEEE · 2026',
        description: 'Elected to the highest professional grade for which a member may apply, held by fewer than 10% of IEEE’s roughly 500,000 members worldwide.',
        url: 'https://ieee-collabratec.ieee.org/app/p/RaviTejaAlchuri',
    },
    {
        id: 2,
        icon: <Landmark size={24} />,
        title: 'Named on the U.S. Federal FMCSA Registry',
        org: 'U.S. DOT / FMCSA · 2026',
        description: 'Recorded as “Updated By: Ravi Teja Alchuri,” the authorized technical maintainer of Apollo ELD’s federal compliance record under 49 CFR Part 395.',
    },
    {
        id: 3,
        icon: <Cpu size={24} />,
        title: 'PoLTE (Acquired by Qualcomm)',
        org: 'Core Engineering Contributor',
        description: 'Core engineer on PoLTE’s patented 4G/5G LTE Positioning Engine, the technology subsequently acquired by Qualcomm Incorporated.',
    },
    {
        id: 4,
        icon: <Truck size={24} />,
        title: 'M2M In Motion (Acquired by AAMP Global)',
        org: 'Core Engineering Team',
        description: 'Core engineering team member of the M2M In Motion fleet telematics platform, later acquired by AAMP Global.',
    },
    {
        id: 5,
        icon: <ShieldCheck size={24} />,
        title: 'Android Enterprise Gold Partner',
        org: 'Google · WeGuard MDM',
        description: 'Key contributor to the WeGuard MDM platform achieving Google’s Android Enterprise Gold partnership, one of the highest tiers of Google’s enterprise certification.',
    },
    {
        id: 6,
        icon: <Gavel size={24} />,
        title: 'DEV Challenge Judge',
        org: 'Online Hackathons',
        description: 'Invited to judge a DEV Challenge and nominate the winning submissions among global participants in online hackathons.',
    },
];
